import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { DashboardService } from '../../services/dashboard.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';


@Component({
    selector: 'dashboard-link',
    templateUrl: './dashboard-link.component.html',
    styleUrls: ['./dashboard-link.component.scss'],
    standalone: false
})
export class DashboardLinkomponent implements OnInit {
  @Input() data: any;

  @Output() configChanged: EventEmitter<any> = new EventEmitter();

  config: any = {};
  constructor(private baseService: BaseService,
    private appService: AppService,
    private loader: LoaderService,
    public router: Router,
    public dialogService: DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService: UtilService,
    public dashBoardService: DashboardService,
    public auth:AuthenticationService
  ) {
  }

  ngOnInit() {
    console.log("this.data===>", this.data);
    this.build();
  }


  build() {
    this.loader.showSpinner();
    this.dashBoardService.getWidgetData(this.data.widget_id, (data) => {
      this.loader.hideSpinner();
      this.config.data = data;
      if (data && data.document_id) {
        this.config.data.bannerUrl = this.utilService.getImageUrl(data.document_id);
      }

    })
  }

  isFullRedirect(link){
    return link.indexOf("?full_redirect=true") > -1;
  }
  isPost(link){
    return link.indexOf("method=post") > -1;
  }
  openLink(link){
    if(this.isFullRedirect(link)){
     window.location.href = link.replace("?full_redirect=true","");
    }else{
      var currentUser = this.auth.getCurrentUser();
      if(this.isPost(link)){
        
        var newLink = "";
        try{
          if(link != undefined){
              try{
                  newLink = this.appService.buildDyanamicStr(link,{id:currentUser["user_id"],identifier:this.appService._currentSessionData["sessionTime"],token:this.appService.btoa_utf8(this.appService.encryptData(currentUser["user_id"]))})
                  this.utilService.openWebsite(newLink,currentUser["user_id"])
                   
                }catch(e){

                }              
          }
            
        }catch(e){
            console.error(e)
        }
      }else{
        this.utilService.openWebsite(link,currentUser["user_id"])
      }      
      
    }
    
  }
  goto(link) {
    var isEmployee = false;
    let _data = {};
    _data["data"] = this.appService.getCurrentUser()
    link = this.baseService.buildDyanamicStr(link, _data);
    //employee check added for fit/unfit
    if (link.includes("/fit_unfit_status")) {
      if (_data["data"] && _data["data"].tag_data && _data["data"].tag_data.length > 0) {
        for(let i = 0; i < _data["data"].tag_data.length; i++) {
          if (_data["data"].tag_data[i].key_name && _data["data"].tag_data[i].key_name.toLowerCase() == 'employee' && _data["data"].tag_data[i].key_value_code.toLowerCase() == 'employee') {
            isEmployee = true;
            this.router.navigate([link]);
            break;
          }
        }
        if (!isEmployee)
          this.alerts.error('Sorry! You Are Not Authorized To Access This Web Page!');
      } else
        this.alerts.error('Sorry! You Are Not Authorized To Access This Web Page!');
    } else
      this.router.navigateByUrl(link);
  }
}
